export default "__VITE_ASSET__a0271062__"